import React from 'react';
import { ConfigProvider } from 'antd';
import { useTheme } from '../../../theme/ThemeContext';
import { AgenticWelcomeHeaderProps } from '../AskAsperAgentic.types';
import AskAsperIcon from '../../../atoms/Icon/AskAsperIcon';

// AskAsper Icon with glow effect
const AskAsperIconWithGlow: React.FC = () => (
    <div className="relative inline-flex items-center justify-center">
        {/* Outer glow container */}
        <div className="relative">
            {/* Background box with shadow */}
            <div className="bg-[#fbfcff] border-[2px] border-solid border-white rounded-[10px] shadow-[0px_2.5px_20px_-2.5px_rgba(99,140,243,0.32)] size-[68px] flex items-center justify-center">
                {/* Blurred glow effect */}
                <div className="absolute inset-1 rounded-[8px] bg-gradient-to-br from-purple-400/30 via-blue-400/30 to-indigo-400/30 blur-[30px]" />
                
                {/* AskAsper Icon */}
                <div className="relative z-10">
                    <AskAsperIcon size={40} />
                </div>
            </div>
        </div>
    </div>
);

/**
 * AgenticWelcomeHeader - Welcome section with logo, greeting, and subtext
 * Part of the AskAsper Agentic Platform components
 */
const AgenticWelcomeHeader: React.FC<AgenticWelcomeHeaderProps> = ({
    userName = 'User',
    greeting,
    subtext = 'What can I help you with today ?',
    showLogo = true,
    'data-test': dataTest,
    'data-test-id': dataTestId,
}) => {
    const theme = useTheme();

    // Generate greeting if not provided
    const displayGreeting = greeting || `Hey ${userName}!`;

    return (
        <ConfigProvider theme={theme}>
            <div
                className="flex flex-col gap-4 items-center"
                data-test={dataTest}
                data-test-id={dataTestId}
                data-agentic-welcome-header
            >
                {/* Logo */}
                {showLogo && <AskAsperIconWithGlow />}

                {/* Text Content */}
                <div className="flex flex-col gap-1 items-center text-center">
                    {/* Main Greeting */}
                    <h1 className="font-['Open_Sans'] font-bold text-[40px] leading-tight text-[#3b2c77] m-0">
                        {displayGreeting}
                    </h1>

                    {/* Subtext */}
                    <p className="font-['Open_Sans'] font-normal text-[32px] leading-tight text-[#3b2c77] m-0">
                        {subtext}
                    </p>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default AgenticWelcomeHeader;
